import * as WebApi from "OK/webapi";
import { AuthLoginPopup } from "OK/AuthLoginPopup";
import {IAuthPopupOpenParams, MsgParams} from "@ok/interfaces/auth/IAuthPopupOpenParams";
import { StateParams } from "@ok/interfaces/auth/StateParams";
import { AuthTriggerAction } from "./AuthTypes";

export class JoinGroupAfterAuth {
    private element: HTMLElement | null = null;
    private groupId: string | null = null;
    private href: string | null = null;
    private loginLayerText: string | null = null;
    private loginLayerHeaderImageConf: Record<string, string> | null = {};
    private stateParams: StateParams | null = null;

    clickHandler = (e: MouseEvent) => {
        e.preventDefault();

        if (this.groupId === null || this.href === null) {
            throw new Error("Group id and href cannot be null!")
        }

        WebApi.invoke('login/addLoginIntentForJoinGroup', {
            groupId: this.groupId,
            href: this.href
        }).then((afterLoginIntent) => {
            const params: IAuthPopupOpenParams = {
                loginIntent: afterLoginIntent,
                text: this.loginLayerText || '',
                headerImage: this.loginLayerHeaderImageConf!,
                stateParams: this.stateParams!,
                popupTriggeringAction: AuthTriggerAction.Group_Enter
            };
            AuthLoginPopup.open(params as MsgParams);
        });
    }

    activate(el: HTMLElement) {
        this.element = el;

        this.groupId = this.element.dataset.groupId || null;
        this.href = (this.element as HTMLAnchorElement).href || this.element.dataset.href || null;
        this.loginLayerText = this.element.dataset.loginLayerText || null;
        this.loginLayerHeaderImageConf = JSON.parse((this.element.dataset.loginLayerHeaderImageConf || null)!);
        this.stateParams = JSON.parse((this.element.dataset.stateParams || null)!);

        this.element.addEventListener('click', this.clickHandler);
    }

    deactivate() {
        this.element?.removeEventListener('click', this.clickHandler);

        this.element = null;
        this.groupId = null;
        this.href = null;
        this.loginLayerText = null;
        this.loginLayerHeaderImageConf = null;
    }
}

export default JoinGroupAfterAuth;
